// src/pages/Identify.jsx
/*import React, { useMemo, useState, useCallback, useEffect } from "react";
import Meta from "../components/Meta";
import Custominput from "../components/Custominput";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { FcGoogle } from "react-icons/fc";
import { IoArrowBack } from "react-icons/io5";
import { Capacitor } from "@capacitor/core";
import { GoogleLogin, useGoogleOneTapLogin } from "@react-oauth/google";
import { useDispatch, useSelector } from "react-redux";

import kuptoLogo from "../images/logo/kupto logobb-8.png";
import "./styles/identify.css";

import { identifyUser, googleLoginUser } from "../app/features/user/userSlice";

const RETURN_TO_KEY = "kupto_returnTo";
const IDENTITY_KEY = "kupto_identity";
const IDENTITY_TYPE_KEY = "kupto_identity_type";

const GOOGLE_WEB_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_CLIENT_ID ||
  "514813559932-epaiecocpq0jr8jvk4au7bh3ukvgp1sp.apps.googleusercontent.com";

const ssGet = (k) => {
  try {
    return sessionStorage.getItem(k) || "";
  } catch {
    return "";
  }
};

const ssSet = (k, v) => {
  try {
    sessionStorage.setItem(k, v);
  } catch {}
};

const isValidEmail = (v) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v || "").trim());

const UG_CC = "256";

const normalizeUgPhoneToE164 = (raw) => {
  const v = String(raw || "").trim();
  if (!v) return "";

  let s = v.replace(/[^\d+]/g, "");

  if (s.startsWith("00")) s = "+" + s.slice(2);
  if (s.startsWith("+256")) return s;
  if (s.startsWith("256")) return "+" + s;

  if (s.startsWith("0")) {
    const rest = s.replace(/^0+/, "");
    return `+${UG_CC}${rest}`;
  }

  if (/^\d+$/.test(s) && s.length >= 7 && s.length <= 9) {
    return `+${UG_CC}${s}`;
  }

  return s.startsWith("+") ? s : "+" + s;
};

const isValidPhone = (v) => {
  const e164 = normalizeUgPhoneToE164(v);
  const onlyDigits = e164.replace(/[^\d]/g, "");
  return onlyDigits.length >= 10 && onlyDigits.length <= 15;
};

const normalizeIdentity = (raw) => {
  const v = String(raw || "").trim();
  if (!v) return { identity: "", type: "" };

  if (isValidEmail(v)) return { identity: v.toLowerCase(), type: "email" };
  return { identity: normalizeUgPhoneToE164(v), type: "phone" };
};

const formatUgPhoneDisplay = (raw) => {
  const v = String(raw || "");
  if (!v.trim()) return "";
  if (/[a-zA-Z@]/.test(v)) return v;

  let s = v.replace(/[^\d+]/g, "");

  if (s === "+" || s === "+2" || s === "+25" || s === "+256") return s;

  if (s.startsWith("00")) s = "+" + s.slice(2);
  if (s.startsWith("+") && !s.startsWith("+256")) return s;

  let digits = s.replace(/[^\d]/g, "");

  if (digits.startsWith("256")) digits = digits.slice(3);
  if (digits.startsWith("0")) digits = digits.replace(/^0+/, "");

  const n = digits.slice(0, 9);

  const p1 = n.slice(0, 1);
  const p2 = n.slice(1, 3);
  const p3 = n.slice(3, 6);
  const p4 = n.slice(6, 9);

  let out = "+256";
  if (n.length > 0) out += " " + p1;
  if (n.length > 1) out += p2 || "";
  if (n.length > 3) out += " " + p3;
  if (n.length > 6) out += " " + p4;

  if (digits.length > 9) out += " " + digits.slice(9);
  return out.trim();
};

const parseExists = (payload) => {
  const p =
    payload?.data && typeof payload.data === "object" ? payload.data : payload;

  const v =
    p?.exists ??
    p?.userExists ??
    p?.isExisting ??
    p?.found ??
    p?.user_found ??
    p?.accountExists;

  if (typeof v === "boolean") return v;
  if (typeof v === "number") return v === 1;
  if (typeof v === "string") return v.toLowerCase() === "true" || v === "1";
  return false;
};

const WebGoogleAuth = ({
  isLoading,
  onGoogleSuccess,
  onGoogleError,
  onGoogleClick,
  googleErr,
}) => {
  useGoogleOneTapLogin({
    onSuccess: onGoogleSuccess,
    onError: () => {},
    disabled: isLoading,
  });

  return (
    <div className="ku-id-social">
      <button
        type="button"
        className="ku-id-socialBtn gg"
        onClick={onGoogleClick}
        disabled={isLoading}
        style={{ position: "relative", overflow: "hidden" }}
      >
        <FcGoogle className="ku-id-ico" />
        <span>Google</span>

        <span
          aria-hidden="true"
          style={{
            position: "absolute",
            inset: 0,
            opacity: 0.0001,
            zIndex: 5,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            pointerEvents: "auto",
          }}
        >
          <GoogleLogin
            onSuccess={onGoogleSuccess}
            onError={onGoogleError}
            useOneTap={false}
            ux_mode="popup"
          />
        </span>
      </button>

      {googleErr ? (
        <div className="ku-id-error" style={{ marginTop: 6 }}>
          {googleErr}
        </div>
      ) : null}
    </div>
  );
};

const Identify = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const authLoading = useSelector((state) => state?.auth?.isLoading);
  const [localLoading, setLocalLoading] = useState(false);
  const isLoading = Boolean(authLoading || localLoading);

  const isNativeAndroid =
    Capacitor.isNativePlatform() && Capacitor.getPlatform() === "android";

  const returnToFromState = location?.state?.returnTo;

  const returnTo = useMemo(() => {
    if (typeof returnToFromState === "string" && returnToFromState.trim()) {
      return returnToFromState.trim();
    }
    const ss = ssGet(RETURN_TO_KEY);
    if (ss && ss.trim()) return ss.trim();
    return "/";
  }, [returnToFromState]);

  const [rawValue, setRawValue] = useState("");
  const [value, setValue] = useState("");
  const [touched, setTouched] = useState(false);

  const [googleErr, setGoogleErr] = useState("");
  const [apiErr, setApiErr] = useState("");
  const [googleInfo, setGoogleInfo] = useState("");

  const looksLikePhone = useMemo(() => {
    const v = String(rawValue || "");
    if (!v.trim()) return false;
    return !/[a-zA-Z@]/.test(v);
  }, [rawValue]);

  const valid = useMemo(() => {
    const v = rawValue.trim();
    if (!v) return false;
    return isValidEmail(v) || isValidPhone(v);
  }, [rawValue]);

  const showError = touched && rawValue.trim() && !valid;

  useEffect(() => {
    if (returnTo && returnTo !== "/") ssSet(RETURN_TO_KEY, returnTo);
  }, [returnTo]);

  useEffect(() => {
    if (!isNativeAndroid) return;

    setGoogleErr(
      "Google Sign-In for Android needs a Capacitor 7-compatible plugin. Please use email/phone login for now."
    );
  }, [isNativeAndroid]);

  const backReturnTo = useMemo(() => {
    return returnTo || ssGet(RETURN_TO_KEY) || "/";
  }, [returnTo]);

  const goBack = useCallback(() => {
    const browserHistoryLength =
      typeof window !== "undefined" && window.history ? window.history.length : 0;

    if (browserHistoryLength > 1) {
      navigate(-1);
      return;
    }

    navigate(backReturnTo || "/", { replace: true });
  }, [navigate, backReturnTo]);

  const onContinue = async (e) => {
    e.preventDefault();
    setTouched(true);
    setApiErr("");
    setGoogleErr("");
    setGoogleInfo("");

    if (!valid) return;

    const { identity, type } = normalizeIdentity(rawValue);

    try {
      setLocalLoading(true);

      const payload = await dispatch(identifyUser({ identity, type })).unwrap();

      const exists = parseExists(payload);
      const p =
        payload?.data && typeof payload.data === "object" ? payload.data : payload;

      const nextIdentity = p?.normalized || p?.identity || identity;
      const nextType = p?.type || type;

      ssSet(RETURN_TO_KEY, returnTo || "/");
      ssSet(IDENTITY_KEY, nextIdentity);
      ssSet(IDENTITY_TYPE_KEY, nextType);

      setLocalLoading(false);

      if (exists) {
        return navigate("/login", {
          state: {
            identity: nextIdentity,
            type: nextType,
            returnTo,
            skipRefresh: true,
          },
        });
      }

      return navigate("/verification-code", {
        state: {
          identity: nextIdentity,
          type: nextType,
          purpose: "signup",
          returnTo,
        },
      });
    } catch (err) {
      console.error(err);
      setLocalLoading(false);
      setApiErr(
        typeof err === "string"
          ? err
          : err?.message ||
              "We couldn’t verify your email/phone right now. Please try again."
      );
    }
  };

  const handleGooglePayload = useCallback(
    async ({ credential, googleProfile = null }) => {
      try {
        if (!credential) {
          setGoogleErr("Missing Google credential.");
          return;
        }

        setLocalLoading(true);
        ssSet(RETURN_TO_KEY, returnTo || "/");

        const payload = await dispatch(googleLoginUser({ credential })).unwrap();

        if (!payload || typeof payload !== "object") {
          setLocalLoading(false);
          setGoogleErr("Google login failed: invalid server response.");
          return;
        }

        if (payload?.profileRequired) {
          const gp = payload?.googleProfile || googleProfile || {};
          const email = String(gp?.email || "").trim();

          if (email) {
            setRawValue(email);
            setValue(email);
            setTouched(false);
          }

          setGoogleInfo(
            payload?.message || "Please complete your profile to continue."
          );
          setLocalLoading(false);

          return navigate("/profile-details", {
            state: { googleProfile: gp, returnTo },
          });
        }

        setLocalLoading(false);
        navigate(returnTo || "/", { replace: true });
      } catch (err) {
        console.error(err);
        setLocalLoading(false);

        const msg =
          typeof err === "string"
            ? err
            : err?.message || "Google sign-in failed. Please try again.";

        if (String(msg).toLowerCase().includes("origin")) {
          setGoogleErr(
            "Google blocked this domain. Add this site to Authorized JavaScript origins in Google Console."
          );
        } else {
          setGoogleErr(msg);
        }
      }
    },
    [dispatch, navigate, returnTo]
  );

  const onGoogleSuccess = useCallback(
    async (credentialResponse) => {
      try {
        setGoogleErr("");
        setApiErr("");
        setGoogleInfo("");

        const credential = credentialResponse?.credential;

        await handleGooglePayload({ credential });
      } catch (err) {
        console.error(err);
        setLocalLoading(false);
        setGoogleErr(err?.message || "Google sign-in failed. Please try again.");
      }
    },
    [handleGooglePayload]
  );

  const onNativeGoogleLogin = useCallback(async () => {
    setGoogleErr(
      "Google Sign-In for Android needs a Capacitor 7-compatible plugin. Please use email/phone login for now."
    );
  }, []);

  const onGoogleError = useCallback(() => {
    setLocalLoading(false);
    setGoogleErr("Google sign-in failed. Please try again.");
  }, []);

  const onGoogleClick = useCallback(() => {
    setGoogleErr("");
    setApiErr("");
    setGoogleInfo("");
  }, []);

  const quickLinks = useMemo(
    () => [
      {
        icon: "❓",
        title: "Help Center",
        desc: "FAQs, order issues, account help",
        to: "/help",
      },
      {
        icon: "☎",
        title: "Contact Support",
        desc: "Call/WhatsApp/email support",
        to: "/contact",
      },
      {
        icon: "↩",
        title: "Returns & Refunds",
        desc: "Refund rules for printing/custom work",
        to: "/refund-policy",
      },
      {
        icon: "₦",
        title: "Print Pricing",
        desc: "See print price list, sizes, turnaround",
        to: "/price-list",
      },
    ],
    []
  );

  const onIdentityChange = (e) => {
    const nextRaw = e.target.value;

    setRawValue(nextRaw);
    setGoogleInfo("");
    setApiErr("");
    setGoogleErr("");

    if (/[a-zA-Z@]/.test(nextRaw)) {
      setValue(nextRaw);
      return;
    }

    if (!nextRaw.trim()) {
      setValue("");
      return;
    }

    setValue(formatUgPhoneDisplay(nextRaw));
  };

  const onIdentityFocus = () => {};

  const onIdentityBlur = () => {
    setTouched(true);
    const digits = normalizeUgPhoneToE164(rawValue).replace(/[^\d]/g, "");
    if (!isValidEmail(rawValue) && digits === "256") {
      setRawValue("");
      setValue("");
    }
  };

  return (
    <>
      <Meta title="Identify" />

      {isLoading ? (
        <div className="ku-id-topLoader" role="status" aria-label="Loading">
          <span className="ku-id-topTrack" aria-hidden="true">
            <span className="ku-id-topBar" />
          </span>
        </div>
      ) : null}

      <div className="ku-id-wrap">
        <div className="ku-id-shell">
          <div className={`ku-id-card ${isLoading ? "is-busy" : ""}`}>
            <button
              type="button"
              className="ku-id-back ku-id-back--appOnly"
              onClick={goBack}
              aria-label="Go back"
              disabled={isLoading}
            >
              <IoArrowBack />
            </button>

            <div className="ku-id-left">
              <div className="ku-id-brand" aria-hidden="true">
                <div className="ku-id-mark">
                  <img
                    src={kuptoLogo}
                    alt="Kupto"
                    className="ku-id-logo"
                    draggable="false"
                  />
                </div>
              </div>

              <div className="ku-id-head">
                <h1 className="ku-id-title">Welcome to Kupto</h1>
                <p className="ku-id-sub">
                  Use your email or phone to log in or sign up.
                </p>
              </div>

              <form className="ku-id-form" onSubmit={onContinue} noValidate>
                <div className="ku-id-field">
                  <div className={`ku-id-input ${showError ? "is-error" : ""}`}>
                    <Custominput
                      type="text"
                      name="identity"
                      placeholder="Email or mobile number"
                      value={value}
                      onChange={onIdentityChange}
                      onFocus={onIdentityFocus}
                      onBlur={onIdentityBlur}
                      inputMode={looksLikePhone ? "tel" : "email"}
                      disabled={isLoading}
                    />
                  </div>

                  {looksLikePhone ? (
                    <div className="ku-id-hint" style={{ marginTop: 6 }}>
                      Format: +256 7xx xxx xxx
                    </div>
                  ) : null}

                  {showError ? (
                    <div className="ku-id-error">
                      Either the email or the phone number entered is not valid
                    </div>
                  ) : null}

                  {googleInfo ? (
                    <div className="ku-id-hint" style={{ marginTop: 6 }}>
                      {googleInfo}
                    </div>
                  ) : null}

                  {apiErr ? (
                    <div className="ku-id-error" style={{ marginTop: 6 }}>
                      {apiErr}
                    </div>
                  ) : null}
                </div>

                <button
                  type="submit"
                  className="ku-id-btn"
                  disabled={!rawValue.trim() || isLoading}
                >
                  Continue
                </button>

                <div className="ku-id-divider">
                  <span>Or log in with</span>
                </div>

                {!isNativeAndroid ? (
                  <WebGoogleAuth
                    isLoading={isLoading}
                    onGoogleSuccess={onGoogleSuccess}
                    onGoogleError={onGoogleError}
                    onGoogleClick={onGoogleClick}
                    googleErr={googleErr}
                  />
                ) : (
                  <div className="ku-id-social">
                    <button
                      type="button"
                      className="ku-id-socialBtn gg"
                      onClick={onNativeGoogleLogin}
                      disabled={isLoading}
                    >
                      <FcGoogle className="ku-id-ico" />
                      <span>Google</span>
                    </button>

                    {googleErr ? (
                      <div className="ku-id-error" style={{ marginTop: 6 }}>
                        {googleErr}
                      </div>
                    ) : null}
                  </div>
                )}

                <p className="ku-id-legal">
                  By continuing you agree to Kupto’s{" "}
                  <Link to="/terms-and-conditions">Terms and Conditions</Link>
                </p>
              </form>

              <span className="ku-id-glow ku-id-glow--1" />
              <span className="ku-id-glow ku-id-glow--2" />
            </div>

            <div className="ku-id-right ku-id-right--desktopOnly">
              <h3 className="ku-id-rightTitle">Quick links</h3>

              <div className="ku-id-rightList">
                {quickLinks.map((item) => (
                  <Link
                    key={item.to}
                    to={item.to}
                    className="ku-id-rightItem ku-id-rightLink"
                    aria-label={item.title}
                    state={{ returnTo }}
                  >
                    <div className="ku-id-rightIcon" aria-hidden="true">
                      {item.icon}
                    </div>

                    <div className="ku-id-rightTextWrap">
                      <p className="ku-id-rightH">{item.title}</p>
                      <p className="ku-id-rightP">{item.desc}</p>
                    </div>

                    <span className="ku-id-rightArrow" aria-hidden="true">
                      ›
                    </span>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Identify;
*/


// src/pages/Identify.jsx

import React, { useMemo, useState, useCallback, useEffect } from "react";
import Meta from "../components/Meta";
import Custominput from "../components/Custominput";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { FcGoogle } from "react-icons/fc";
import { IoArrowBack } from "react-icons/io5";
import { Capacitor } from "@capacitor/core";
import { GoogleLogin, useGoogleOneTapLogin } from "@react-oauth/google";
//import { GoogleSignIn } from "@capawesome/capacitor-google-sign-in";
import { GoogleAuth } from "@codetrix-studio/capacitor-google-auth";
import { useDispatch, useSelector } from "react-redux";

import kuptoLogo from "../images/logo/kupto logobb-8.png";
import "./styles/identify.css";

import { identifyUser, googleLoginUser } from "../app/features/user/userSlice";

/* =========================
   SESSION KEYS
========================= */
const RETURN_TO_KEY = "kupto_returnTo";
const IDENTITY_KEY = "kupto_identity";
const IDENTITY_TYPE_KEY = "kupto_identity_type";

/* =========================
   GOOGLE CLIENT ID
   IMPORTANT:
   Use your WEB client ID here, not Android client ID.
========================= */
const GOOGLE_WEB_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_CLIENT_ID ||
  "514813559932-epaiecocpq0jr8jvk4au7bh3ukvgp1sp.apps.googleusercontent.com";

/* =========================
   SAFE SESSION HELPERS
========================= */
const ssGet = (k) => {
  try {
    return sessionStorage.getItem(k) || "";
  } catch {
    return "";
  }
};

const ssSet = (k, v) => {
  try {
    sessionStorage.setItem(k, v);
  } catch {}
};

const isValidEmail = (v) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v || "").trim());

const UG_CC = "256";

/** Normalize UG phones into E.164 (+2567XXXXXXXX) */
const normalizeUgPhoneToE164 = (raw) => {
  const v = String(raw || "").trim();
  if (!v) return "";

  let s = v.replace(/[^\d+]/g, "");

  if (s.startsWith("00")) s = "+" + s.slice(2);
  if (s.startsWith("+256")) return s;
  if (s.startsWith("256")) return "+" + s;

  if (s.startsWith("0")) {
    const rest = s.replace(/^0+/, "");
    return `+${UG_CC}${rest}`;
  }

  // allow typing without 0: 701xxxxxxx or 712...
  if (/^\d+$/.test(s) && s.length >= 7 && s.length <= 9) {
    return `+${UG_CC}${s}`;
  }

  return s.startsWith("+") ? s : "+" + s;
};

const isValidPhone = (v) => {
  const e164 = normalizeUgPhoneToE164(v);
  const onlyDigits = e164.replace(/[^\d]/g, "");
  return onlyDigits.length >= 10 && onlyDigits.length <= 15;
};

/** normalize input (email or phone->E164) */
const normalizeIdentity = (raw) => {
  const v = String(raw || "").trim();
  if (!v) return { identity: "", type: "" };

  if (isValidEmail(v)) return { identity: v.toLowerCase(), type: "email" };
  return { identity: normalizeUgPhoneToE164(v), type: "phone" };
};

/**
 * Display formatter for UG numbers:
 * Shows: "+256 7xx xxx xxx" while typing,
 * but does NOT force rebuild while deleting
 */
const formatUgPhoneDisplay = (raw) => {
  const v = String(raw || "");
  if (!v.trim()) return "";

  // If it looks like email typing, don't format
  if (/[a-zA-Z@]/.test(v)) return v;

  let s = v.replace(/[^\d+]/g, "");

  // allow partial "+", "+2", "+25", "+256"
  if (s === "+" || s === "+2" || s === "+25" || s === "+256") return s;

  if (s.startsWith("00")) s = "+" + s.slice(2);

  // If starts with + but not +256, keep as-is
  if (s.startsWith("+") && !s.startsWith("+256")) return s;

  let digits = s.replace(/[^\d]/g, "");

  if (digits.startsWith("256")) digits = digits.slice(3);
  if (digits.startsWith("0")) digits = digits.replace(/^0+/, "");

  const national = digits;
  const n = national.slice(0, 9);

  const p1 = n.slice(0, 1);
  const p2 = n.slice(1, 3);
  const p3 = n.slice(3, 6);
  const p4 = n.slice(6, 9);

  let out = "+256";
  if (n.length > 0) out += " " + p1;
  if (n.length > 1) out += p2 ? p2 : "";
  if (n.length > 3) out += " " + p3;
  if (n.length > 6) out += " " + p4;

  if (national.length > 9) out += " " + national.slice(9);
  return out.trim();
};

/* =========================
   EXISTENCE PARSER
========================= */
const parseExists = (payload) => {
  const p =
    payload?.data && typeof payload.data === "object" ? payload.data : payload;

  const v =
    p?.exists ??
    p?.userExists ??
    p?.isExisting ??
    p?.found ??
    p?.user_found ??
    p?.accountExists;

  if (typeof v === "boolean") return v;
  if (typeof v === "number") return v === 1;
  if (typeof v === "string") return v.toLowerCase() === "true" || v === "1";
  return false;
};

/* =========================================================
   WEB GOOGLE AUTH ONLY
========================================================= */
const WebGoogleAuth = ({
  isLoading,
  onGoogleSuccess,
  onGoogleError,
  onGoogleClick,
  googleErr,
}) => {
  useGoogleOneTapLogin({
    onSuccess: onGoogleSuccess,
    onError: () => {},
    disabled: isLoading,
  });

  return (
    <div className="ku-id-social">
      <button
        type="button"
        className="ku-id-socialBtn gg"
        onClick={onGoogleClick}
        disabled={isLoading}
        style={{ position: "relative", overflow: "hidden" }}
      >
        <FcGoogle className="ku-id-ico" />
        <span>Google</span>

        <span
          aria-hidden="true"
          style={{
            position: "absolute",
            inset: 0,
            opacity: 0.0001,
            zIndex: 5,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            pointerEvents: "auto",
          }}
        >
          <GoogleLogin
            onSuccess={onGoogleSuccess}
            onError={onGoogleError}
            useOneTap={false}
            ux_mode="popup"
          />
        </span>
      </button>

      {googleErr ? (
        <div className="ku-id-error" style={{ marginTop: 6 }}>
          {googleErr}
        </div>
      ) : null}
    </div>
  );
};

const Identify = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const authLoading = useSelector((state) => state?.auth?.isLoading);
  const [localLoading, setLocalLoading] = useState(false);
  const isLoading = Boolean(authLoading || localLoading);

  const isNativeAndroid =
    Capacitor.isNativePlatform() && Capacitor.getPlatform() === "android";

  const returnToFromState = location?.state?.returnTo;

  const returnTo = useMemo(() => {
    if (typeof returnToFromState === "string" && returnToFromState.trim()) {
      return returnToFromState.trim();
    }
    const ss = ssGet(RETURN_TO_KEY);
    if (ss && ss.trim()) return ss.trim();
    return "/";
  }, [returnToFromState]);

  const [rawValue, setRawValue] = useState("");
  const [value, setValue] = useState("");
  const [touched, setTouched] = useState(false);

  const [googleErr, setGoogleErr] = useState("");
  const [apiErr, setApiErr] = useState("");
  const [googleInfo, setGoogleInfo] = useState("");

  const looksLikePhone = useMemo(() => {
    const v = String(rawValue || "");
    if (!v.trim()) return false;
    return !/[a-zA-Z@]/.test(v);
  }, [rawValue]);

  const valid = useMemo(() => {
    const v = rawValue.trim();
    if (!v) return false;
    return isValidEmail(v) || isValidPhone(v);
  }, [rawValue]);

  const showError = touched && rawValue.trim() && !valid;

  // preserve returnTo across refresh
  useEffect(() => {
    if (returnTo && returnTo !== "/") ssSet(RETURN_TO_KEY, returnTo);
  }, [returnTo]);



  const backReturnTo = useMemo(() => {
    return returnTo || ssGet(RETURN_TO_KEY) || "/";
  }, [returnTo]);

  const goBack = useCallback(() => {
    const browserHistoryLength =
      typeof window !== "undefined" && window.history ? window.history.length : 0;

    if (browserHistoryLength > 1) {
      navigate(-1);
      return;
    }

    navigate(backReturnTo || "/", { replace: true });
  }, [navigate, backReturnTo]);

  const onContinue = async (e) => {
    e.preventDefault();
    setTouched(true);
    setApiErr("");
    setGoogleErr("");
    setGoogleInfo("");

    if (!valid) return;

    const { identity, type } = normalizeIdentity(rawValue);

    try {
      setLocalLoading(true);

      const payload = await dispatch(identifyUser({ identity, type })).unwrap();

      const exists = parseExists(payload);
      const p =
        payload?.data && typeof payload.data === "object" ? payload.data : payload;
      const nextIdentity = p?.normalized || p?.identity || identity;
      const nextType = p?.type || type;

      ssSet(RETURN_TO_KEY, returnTo || "/");
      ssSet(IDENTITY_KEY, nextIdentity);
      ssSet(IDENTITY_TYPE_KEY, nextType);

      setLocalLoading(false);

      if (exists) {
        return navigate("/login", {
          state: {
            identity: nextIdentity,
            type: nextType,
            returnTo,
            skipRefresh: true,
          },
        });
      }

      return navigate("/verification-code", {
        state: {
          identity: nextIdentity,
          type: nextType,
          purpose: "signup",
          returnTo,
        },
      });
    } catch (err) {
      console.error(err);
      setLocalLoading(false);
      setApiErr(
        typeof err === "string"
          ? err
          : err?.message ||
              "We couldn’t verify your email/phone right now. Please try again."
      );
    }
  };

  const handleGooglePayload = useCallback(
    async ({ credential, googleProfile = null }) => {
      try {
        if (!credential) {
          setGoogleErr("Missing Google credential.");
          return;
        }

        setLocalLoading(true);
        ssSet(RETURN_TO_KEY, returnTo || "/");

        const payload = await dispatch(googleLoginUser({ credential })).unwrap();

        if (!payload || typeof payload !== "object") {
          setLocalLoading(false);
          setGoogleErr("Google login failed: invalid server response.");
          return;
        }

        if (payload?.profileRequired) {
          const gp = payload?.googleProfile || googleProfile || {};
          const email = String(gp?.email || "").trim();

          if (email) {
            setRawValue(email);
            setValue(email);
            setTouched(false);
          }

          setGoogleInfo(
            payload?.message || "Please complete your profile to continue."
          );
          setLocalLoading(false);

          return navigate("/profile-details", {
            state: { googleProfile: gp, returnTo },
          });
        }

        setLocalLoading(false);
        navigate(returnTo || "/", { replace: true });
      } catch (err) {
        console.error(err);
        setLocalLoading(false);

        const msg =
          typeof err === "string"
            ? err
            : err?.message || "Google sign-in failed. Please try again.";

        if (String(msg).toLowerCase().includes("origin")) {
          setGoogleErr(
            "Google blocked this domain. Add this site to Authorized JavaScript origins in Google Console."
          );
        } else {
          setGoogleErr(msg);
        }
      }
    },
    [dispatch, navigate, returnTo]
  );

  const onGoogleSuccess = useCallback(
    async (credentialResponse) => {
      try {
        setGoogleErr("");
        setApiErr("");
        setGoogleInfo("");

        const credential = credentialResponse?.credential;

        await handleGooglePayload({ credential });
      } catch (err) {
        console.error(err);
        setLocalLoading(false);
        setGoogleErr(err?.message || "Google sign-in failed. Please try again.");
      }
    },
    [handleGooglePayload]
  );

  const onNativeGoogleLogin = useCallback(async () => {
    try {
      setGoogleErr("");
      setApiErr("");
      setGoogleInfo("");

      if (!GOOGLE_WEB_CLIENT_ID) {
        setGoogleErr("Missing Google web client ID.");
        return;
      }

      setLocalLoading(true);

      GoogleAuth.initialize({
        clientId: GOOGLE_WEB_CLIENT_ID,
        scopes: ["profile", "email"],
        grantOfflineAccess: true,
      });

      const result = await GoogleAuth.signIn();

      const credential = result?.authentication?.idToken;

      if (!credential) {
        setLocalLoading(false);
        setGoogleErr("Google sign-in did not return an ID token.");
        return;
      }

      const googleProfile = {
        googleId: result?.userId || "",
        email: result?.email || "",
        firstname: result?.givenName || "",
        lastname: result?.familyName || "",
        picture: result?.imageUrl || "",
      };

      setLocalLoading(false);

      await handleGooglePayload({ credential, googleProfile });
    } catch (err) {
      console.error("Native Google sign-in failed:", err);
      setLocalLoading(false);

      const code = String(err?.code || "").toLowerCase();
      const msg = String(err?.message || "").trim();

      if (code.includes("cancel") || msg.toLowerCase().includes("cancel")) {
        setGoogleErr("");
        return;
      }

      setGoogleErr(msg || "Google sign-in failed. Please try again.");
    }
  }, [handleGooglePayload]);

  const onGoogleError = useCallback(() => {
    setLocalLoading(false);
    setGoogleErr("Google sign-in failed. Please try again.");
  }, []);

  const onGoogleClick = useCallback(() => {
    setGoogleErr("");
    setApiErr("");
    setGoogleInfo("");
  }, []);

  const quickLinks = useMemo(
    () => [
      {
        icon: "❓",
        title: "Help Center",
        desc: "FAQs, order issues, account help",
        to: "/help",
      },
      {
        icon: "☎",
        title: "Contact Support",
        desc: "Call/WhatsApp/email support",
        to: "/contact",
      },
      {
        icon: "↩",
        title: "Returns & Refunds",
        desc: "Refund rules for printing/custom work",
        to: "/refund-policy",
      },
      {
        icon: "₦",
        title: "Print Pricing",
        desc: "See print price list, sizes, turnaround",
        to: "/price-list",
      },
    ],
    []
  );

  const onIdentityChange = (e) => {
    const nextRaw = e.target.value;

    setRawValue(nextRaw);
    setGoogleInfo("");
    setApiErr("");
    setGoogleErr("");

    if (/[a-zA-Z@]/.test(nextRaw)) {
      setValue(nextRaw);
      return;
    }

    if (!nextRaw.trim()) {
      setValue("");
      return;
    }

    setValue(formatUgPhoneDisplay(nextRaw));
  };

  const onIdentityFocus = () => {};

  const onIdentityBlur = () => {
    setTouched(true);
    const digits = normalizeUgPhoneToE164(rawValue).replace(/[^\d]/g, "");
    if (!isValidEmail(rawValue) && digits === "256") {
      setRawValue("");
      setValue("");
    }
  };

  return (
    <>
      <Meta title="Identify" />

      {isLoading ? (
        <div className="ku-id-topLoader" role="status" aria-label="Loading">
          <span className="ku-id-topTrack" aria-hidden="true">
            <span className="ku-id-topBar" />
          </span>
        </div>
      ) : null}

      <div className="ku-id-wrap">
        <div className="ku-id-shell">
          <div className={`ku-id-card ${isLoading ? "is-busy" : ""}`}>
            <button
              type="button"
              className="ku-id-back ku-id-back--appOnly"
              onClick={goBack}
              aria-label="Go back"
              disabled={isLoading}
            >
              <IoArrowBack />
            </button>

            <div className="ku-id-left">
              <div className="ku-id-brand" aria-hidden="true">
                <div className="ku-id-mark">
                  <img
                    src={kuptoLogo}
                    alt="Kupto"
                    className="ku-id-logo"
                    draggable="false"
                  />
                </div>
              </div>

              <div className="ku-id-head">
                <h1 className="ku-id-title">Welcome to Kupto</h1>
                <p className="ku-id-sub">
                  Use your email or phone to log in or sign up.
                </p>
              </div>

              <form className="ku-id-form" onSubmit={onContinue} noValidate>
                <div className="ku-id-field">
                  <div className={`ku-id-input ${showError ? "is-error" : ""}`}>
                    <Custominput
                      type="text"
                      name="identity"
                      placeholder="Email or mobile number"
                      value={value}
                      onChange={onIdentityChange}
                      onFocus={onIdentityFocus}
                      onBlur={onIdentityBlur}
                      inputMode={looksLikePhone ? "tel" : "email"}
                      disabled={isLoading}
                    />
                  </div>

                  {looksLikePhone ? (
                    <div className="ku-id-hint" style={{ marginTop: 6 }}>
                      Format: +256 7xx xxx xxx
                    </div>
                  ) : null}

                  {showError ? (
                    <div className="ku-id-error">
                      Either the email or the phone number entered is not valid
                    </div>
                  ) : null}

                  {googleInfo ? (
                    <div className="ku-id-hint" style={{ marginTop: 6 }}>
                      {googleInfo}
                    </div>
                  ) : null}

                  {apiErr ? (
                    <div className="ku-id-error" style={{ marginTop: 6 }}>
                      {apiErr}
                    </div>
                  ) : null}
                </div>

                <button
                  type="submit"
                  className="ku-id-btn"
                  disabled={!rawValue.trim() || isLoading}
                >
                  Continue
                </button>

                <div className="ku-id-divider">
                  <span>Or log in with</span>
                </div>

                {!isNativeAndroid ? (
                  <WebGoogleAuth
                    isLoading={isLoading}
                    onGoogleSuccess={onGoogleSuccess}
                    onGoogleError={onGoogleError}
                    onGoogleClick={onGoogleClick}
                    googleErr={googleErr}
                  />
                ) : (
                  <div className="ku-id-social">
                    <button
                      type="button"
                      className="ku-id-socialBtn gg"
                      onClick={onNativeGoogleLogin}
                      disabled={isLoading}
                    >
                      <FcGoogle className="ku-id-ico" />
                      <span>Google</span>
                    </button>

                    {googleErr ? (
                      <div className="ku-id-error" style={{ marginTop: 6 }}>
                        {googleErr}
                      </div>
                    ) : null}
                  </div>
                )}

                <p className="ku-id-legal">
                  By continuing you agree to Kupto’s{" "}
                  <Link to="/terms-and-conditions">Terms and Conditions</Link>
                </p>
              </form>

              <span className="ku-id-glow ku-id-glow--1" />
              <span className="ku-id-glow ku-id-glow--2" />
            </div>

            <div className="ku-id-right ku-id-right--desktopOnly">
              <h3 className="ku-id-rightTitle">Quick links</h3>

              <div className="ku-id-rightList">
                {quickLinks.map((item) => (
                  <Link
                    key={item.to}
                    to={item.to}
                    className="ku-id-rightItem ku-id-rightLink"
                    aria-label={item.title}
                    state={{ returnTo }}
                  >
                    <div className="ku-id-rightIcon" aria-hidden="true">
                      {item.icon}
                    </div>

                    <div className="ku-id-rightTextWrap">
                      <p className="ku-id-rightH">{item.title}</p>
                      <p className="ku-id-rightP">{item.desc}</p>
                    </div>

                    <span className="ku-id-rightArrow" aria-hidden="true">
                      ›
                    </span>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Identify;